import { rootApi } from "@/services/api/api";
import type {
  AllPaymentPlansResponse,
  AllTariffResponse,
  CalculatePricePayload,
  CalculatePriceResponse,
  PaymentUrlPayload,
  PaymentUrlResponse,
} from "@/services/api/entities/payment/types";

export const paymentApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllPlans: builder.query<AllPaymentPlansResponse, { externalId?: string }>({
      query: (params) => ({
        url: "/payment/plan/all",
        method: "GET",
        params,
      }),
    }),
    getAllTariffs: builder.query<AllTariffResponse, { externalId?: string }>({
      query: (params) => ({
        url: "/payment/tariff/all",
        method: "GET",
        params,
      }),
    }),
    getPaymentUrl: builder.mutation<PaymentUrlResponse, PaymentUrlPayload>({
      query: (body) => ({
        url: "/payment/operation",
        method: "POST",
        body,
      }),
    }),
    getPaymentStatus: builder.query<PaymentUrlResponse, { paymentOperationId: string }>({
      query: (params) => ({
        url: "/payment/operation",
        method: "GET",
        params,
      }),
    }),
    getPriceCalculation: builder.query<CalculatePriceResponse, CalculatePricePayload>({
      query: (body) => ({
        url: "/payment/calculate",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useLazyGetAllPlansQuery,
  useGetPaymentUrlMutation,
  useGetPaymentStatusQuery,
  useGetAllTariffsQuery,
  useGetPriceCalculationQuery,
} = paymentApi;
